import CustomAxios from "..";

export const getAllMediaSource = async (folder) => {
  try {
    const response = await CustomAxios.get("upload/cdn/url", {
      params: {
        folder: folder,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching media data:", error);
    throw error;
  }
};
